var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoomerangBrokenBoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b59767;}.cls-2{fill:#e2b985;}.cls-3{fill:#156392;}.cls-4{fill:#1c79be;}.cls-5{fill:#5c4a37;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boomerang") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brokenBoom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boomerang-2",
    "data-name": "boomerang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.55,191.19h9.56V181l11.11,5.08,4.45-7.94,5.39,3.5,3.5-8.26,8.25,3.81,1.86-3.71c29.12,49.09,193.23,47.7,194.65,70.16C289.14,272.28,85.51,262.83,48.55,191.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.32,243.67c1,11.12-62.61,13.17-125.36,1.38C113.75,236,66,218.76,48.42,191.19h9.69V181l11.11,5.08,4.45-7.94,5.39,3.5,3.5-8.26,8.25,3.81,1.73-3.46c13.25,18.62,46.75,30,82.3,38.41C228.2,224.75,286.2,230.53,287.32,243.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.06,156.7,88,161.05l-5.75-7-7,6.86-3.06-6.47-7.47,5.19-6.62-7.73-4.26,7.2-9.93-3.94A128.54,128.54,0,0,1,45,141.56C55.78,65.08,132,11.38,135.65,30.87c4.65,25-34.37,72.12-43.22,113.5C91.56,148.46,91.32,154,92.06,156.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.66,153.71l-3.07,2.36-5.75-7-6.76,5.9-3.32-5.5-7.47,5.19-7.77-9.43-4.44,9.14-8.71-4.24a46,46,0,0,1,0-11.27c9.69-76,87.08-125.94,90.57-109.78,4.13,19.13-34.3,71.55-43.1,112.61A32,32,0,0,0,91.66,153.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-3",
    "data-name": "boomerang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183,248.5l-.13,6.57a358,358,0,0,1-56.71-12.43l-.19-6v-.06c11.65,3.38,23.81,6.19,36,8.48C169,246.37,176,247.52,183,248.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.7,215.92s-.21.28-.57.84a42.79,42.79,0,0,0-4.66,10.76c-2.28,7.72-3.49,21-3.49,21-7-1-14-2.13-21-3.45-12.19-2.29-24.35-5.1-36-8.48-.06-.72-.52-7.88,2.35-17.91,2.64-9.21,5.64-14.5,7-16.59.47-.72.74-1.06.74-1.06a356.76,356.76,0,0,0,38.81,11.16C180.43,213.49,186.08,214.73,191.7,215.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.69,217s-.18.28-.48.82a58.6,58.6,0,0,0-4.58,10.64c-2.34,7.18-3.31,20.81-3.31,20.81v6.58l-3.09-.41-2.38-.31h0l.13-6.57s1.21-13.26,3.49-21a42.79,42.79,0,0,1,4.66-10.76c.36-.56.57-.84.57-.84l.9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136,201s-.27.34-.74,1.06c-1.35,2.09-4.35,7.38-7,16.59-2.87,10-2.41,17.19-2.35,17.91v.06l.19,6-.24-.08-4.6-1.5-.31-6v0a57.07,57.07,0,0,1,2.48-17.37,77.82,77.82,0,0,1,7.32-17.32c.4-.68.63-1,.63-1l2.32.85Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomerangBrokenBoom);
export default __webpack_public_path__ + "static/media/boomerang_brokenBoom.2de438a46d165f7df90d210b6059f075.svg";
export { ForwardRef as ReactComponent };